<form [formGroup]="taxResidencyForm()">
  <h2>Skatterättslig hemvist</h2>
  <p>Skatterättslig hemvist är det land där en person betalar skatt och
    deklarerar sin inkomst, vanligtvis där personen bor eller arbetar och har
    skatteplikt enligt nationell lagstiftning.</p>
  <p>En person kan ha skatterättslig hemvist i flera länder.</p>

  <p class="select-title">Har du skatterättslig hemvist i Sverige?</p>
  <mat-radio-group
    tabindex="0"
    class="column"
    formControlName="taxResidencySwedish"
    aria-required="true"
    [class.selection-error]="taxResidencyForm().get('taxResidencySwedish')?.invalid && taxResidencyForm().get('taxResidencySwedish')?.touched"
    [attr.aria-invalid]="taxResidencyForm().get('taxResidencySwedish')?.invalid && taxResidencyForm().get('taxResidencySwedish')?.touched"
    [attr.aria-describedby]="taxResidencyForm().get('taxResidencySwedish')?.invalid && taxResidencyForm().get('taxResidencySwedish')?.touched ? 'swedish-residence-error' : null"
  >
    <mat-radio-button [value]="true">Ja</mat-radio-button>
    <mat-radio-button [value]="false">Nej</mat-radio-button>
  </mat-radio-group>

  @if (taxResidencyForm().get('taxResidencySwedish')?.invalid && taxResidencyForm().get('taxResidencySwedish')?.touched) {
    <div class="mat-error-container">
      <mat-icon aria-hidden="true" class="negative">priority_high</mat-icon>
      <mat-error id="swedish-residence-error">Vänligen gör ett val</mat-error>
    </div>
  }

  <div>
    <p class="select-title">Har du skatterättslig hemvist i andra länder?</p>
    <mat-radio-group
      tabindex="0"
      class="column"
      formControlName="taxResidencyNotSwedish"
      aria-required="true"
      [class.selection-error]="taxResidencyForm().get('taxResidencyNotSwedish')?.invalid && taxResidencyForm().get('taxResidencyNotSwedish')?.touched"
      [attr.aria-invalid]="taxResidencyForm().get('taxResidencyNotSwedish')?.invalid && taxResidencyForm().get('taxResidencyNotSwedish')?.touched"
      [attr.aria-describedby]="taxResidencyForm().get('taxResidencyNotSwedish')?.invalid && taxResidencyForm().get('taxResidencyNotSwedish')?.touched ? 'other-residence-error' : null">
      <mat-radio-button [value]="true">Ja</mat-radio-button>
      <mat-radio-button [value]="false">Nej</mat-radio-button>
    </mat-radio-group>
  </div>

  @if (taxResidencyForm().get('taxResidencyNotSwedish')?.invalid && taxResidencyForm().get('taxResidencyNotSwedish')?.touched) {
    <div class="mat-error-container">
      <mat-icon aria-hidden="true" class="negative">priority_high</mat-icon>
      <mat-error id="other-residence-error">Vänligen gör ett val</mat-error>
    </div>
  }

  @if (checkIfSwedenOnly()) {
    <p class="select-title">Då du angett primärt boende utanför Sverige,
      behöver du intyga att du inte har skatterättslig hemvist i annat land än
      Sverige.</p>
    <mat-checkbox
      class="column"
      formControlName="onlySwedenTaxCheckbox"
      aria-required="true"
      [class.selection-error]="taxResidencyForm().get('onlySwedenTaxCheckbox')?.invalid && taxResidencyForm().get('onlySwedenTaxCheckbox')?.touched"
      [attr.aria-invalid]="taxResidencyForm().get('onlySwedenTaxCheckbox')?.invalid && taxResidencyForm().get('onlySwedenTaxCheckbox')?.touched"
      [attr.aria-describedby]="taxResidencyForm().get('onlySwedenTaxCheckbox')?.invalid && taxResidencyForm().get('onlySwedenTaxCheckbox')?.touched ? 'sweden-only-error' : null"
      (keydown.enter)="taxResidencyForm().patchValue({onlySwedenTaxCheckbox: !taxResidencyForm().get('onlySwedenTaxCheckbox')?.value}); $event.preventDefault()">
      Jag intygar att jag inte har skatterättslig hemvist i annat land än
      Sverige
    </mat-checkbox>

    @if (taxResidencyForm().get('onlySwedenTaxCheckbox')?.invalid && taxResidencyForm().get('onlySwedenTaxCheckbox')?.touched) {
      <div class="mat-error-container">
        <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
        <mat-error id="sweden-only-error">Du behöver kryssa i rutan för att
          kunna fortsätta
        </mat-error>
      </div>
    }
  }

  @if (taxResidencyForm().controls.taxResidencyNotSwedish.value === false && checkIfUsaPerson()) {
    <p>Då du angett en födelseort i USA, medborgarskap i
      USA och/eller har ett amerikanskt uppehålls- och arbetstillstånd är du
      troligen skattskyldig i USA.
      Om detta stämmer, vänligen ändra ditt svar till Ja och ange sedan USA som
      skatterättslig hemvist och TIN.</p>
    <p class="select-title">Om du har upphört att vara amerikansk medborgare,
      behöver du intyga
      detta.
    </p>
    <mat-checkbox
      class="column"
      formControlName="notUsaCitizenCheckbox"
      aria-required="true"
      [class.selection-error]="taxResidencyForm().get('notUsaCitizenCheckbox')?.invalid && taxResidencyForm().get('notUsaCitizenCheckbox')?.touched"
      [attr.aria-invalid]="taxResidencyForm().get('notUsaCitizenCheckbox')?.invalid && taxResidencyForm().get('notUsaCitizenCheckbox')?.touched"
      [attr.aria-describedby]="taxResidencyForm().get('notUsaCitizenCheckbox')?.invalid && taxResidencyForm().get('notUsaCitizenCheckbox')?.touched ? 'not-usa-citizen-error' : null"
      (keydown.enter)="taxResidencyForm().patchValue({notUsaCitizenCheckbox: !taxResidencyForm().get('notUsaCitizenCheckbox')?.value}); $event.preventDefault()">
      Jag intygar att jag upphört att vara amerikansk medborgare
    </mat-checkbox>

    @if (taxResidencyForm().get('notUsaCitizenCheckbox')?.invalid && taxResidencyForm().get('notUsaCitizenCheckbox')?.touched) {
      <div class="mat-error-container">
        <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
        <mat-error id="not-usa-citizen-error">Du behöver kryssa i rutan för att
          kunna fortsätta
        </mat-error>
      </div>
    }
  }

  @if (taxResidencyForm().controls.taxResidencyNotSwedish.value) {
    <p>Banken har skyldighet att fråga om uppgifter till följd av avtal om
      informationsinhämtning gällande FATCA/CRS.
      <a
        spbAccessibleLink
        href="https://www.swedishbankers.se/media/3531/1710_crs.pdf"
        target="_blank"
        aria-label="Läs mer om FATCA/CRS (öppnas i nytt fönster)">Klicka här för
        att läsa mer om FATCA/CRS</a>.

      Om du vill ha information om skatteregler i olika länder.
      <a
        spbAccessibleLink
        href="https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/#d.en.347759"
        target="_blank"
        aria-label="Läs mer om respektive lands skatteregistreringsnummer/TIN (öppnas i nytt fönster)">Klicka
        här för att läsa mer om respektive lands
        skatteregistreringsnummer/TIN</a>.
    </p>

    <div
      [class.small-screen]="orientationService.isSmallScreen()"
    >
      @for (formGroup of formGroups; track $index) {
        <p>Vänligen ange i vilket land du har skatterättslig hemvist
          samt skatteregistreringsnummer/TIN och din relation till landet.</p>

        @if ($index === 0) {
          <p>Om du har skatterättslig hemvist i flera länder, klicka på "Lägg
            till fler" nedan.</p>
        }
        <div [formGroup]="formGroup">
          <div class="select-country">
            <mat-form-field
              [class.small-screen]="orientationService.isSmallScreen()"
            >
              <mat-label>Välj land</mat-label>
              <mat-select
                placeholder="Välj land"
                formControlName="taxResidencyCountry">
                @for (country of countryList; track $index) {
                  <mat-option
                    [value]="country.name">{{ country.name }}
                  </mat-option>
                }
              </mat-select>

              @if (formGroup.controls.taxResidencyCountry.errors && formGroup.controls.taxResidencyCountry.touched) {
                <mat-icon matIconSuffix aria-hidden="true">
                  priority_high
                </mat-icon>
              }

              <mat-error>Vänligen gör ett val</mat-error>
            </mat-form-field>
            @if ($index !== 0 && $index === (formGroups.length - 1)) {
              <button mat-icon-button (click)="removeControl($index)"
                      aria-label="Ta bort detta land">
                <mat-icon class="negative">delete</mat-icon>
              </button>
            }
          </div>
          <div>
            <mat-form-field
              [class.small-screen]="orientationService.isSmallScreen()"
            >
              <mat-label>Ange Skatteregistreringsnummer/TIN</mat-label>
              <input
                placeholder="Skatteregistreringsnummer"
                formControlName="taxResidencyTin"
                matInput type="text">

              @if (formGroup.controls.taxResidencyTin.errors && formGroup.controls.taxResidencyTin.touched) {
                <mat-icon matIconSuffix aria-hidden="true">
                  priority_high
                </mat-icon>
              }

              @if (formGroup.controls.taxResidencyTin.invalid && formGroup.controls.taxResidencyTin.touched) {
                <mat-error>Vänligen ange Skatteregistreringsnummer/TIN</mat-error>
              }

            </mat-form-field>
          </div>
          <p class="select-title">Din relation till landet.</p>
          <div class="column" [style.margin-bottom.px]="20">
            @for (option of workingAbroadOptions; track option.value) {
              <mat-checkbox
                [checked]="option.value === formGroup.controls.taxResidencyRelation.value"
                (change)="onCheckboxChange(option.value, 'taxResidencyRelation', $event.checked, formGroup)"
                (keydown.enter)="onCheckboxChange(option.value, 'taxResidencyRelation', !(option.value === formGroup.controls.taxResidencyRelation.value), formGroup); $event.preventDefault()"
                aria-required="true"
                [attr.aria-invalid]="formGroup.get('taxResidencyRelation')?.invalid && formGroup.get('taxResidencyRelation')?.touched"
                [attr.aria-describedby]="'relation-error-' + $index">
                {{ option.label }}
              </mat-checkbox>

              @if (option.value === 'other' &&
              formGroup.controls.taxResidencyRelation.value === 'other') {
                <div>
                  <mat-form-field
                    [class.small-screen]="orientationService.isSmallScreen()"
                  >
                    <mat-label>Ange din relation till landet</mat-label>
                    <input placeholder="Ange din relation till landet"
                           formControlName="taxResidencyOtherRelation"
                           matInput
                           type="text">

                    @if (formGroup.controls.taxResidencyOtherRelation.errors && formGroup.controls.taxResidencyOtherRelation.touched) {
                      <mat-icon matIconSuffix aria-hidden="true">
                        priority_high
                      </mat-icon>
                    }

                    @if (formGroup.controls.taxResidencyOtherRelation.touched) {
                      <mat-error>
                        Vänligen ange din relation till landet
                      </mat-error>
                    }

                  </mat-form-field>
                </div>
              }
            }
          </div>

          @if (formGroup.get('taxResidencyRelation')?.invalid && formGroup.get('taxResidencyRelation')?.touched) {
            <div class="mat-error-container">
              <mat-icon aria-hidden="true">priority_high</mat-icon>
              <mat-error id="relation-error-{{$index}}">Vänligen välj din
                relation till landet
              </mat-error>
            </div>
          }
        </div>
      }
      <button matButton="outlined"
              (click)="addControlsToFormGroup()"
              aria-label="Lägg till ytterligare ett land för skatterättslig hemvist">
        <div class="centered-container">
          <mat-icon aria-hidden="true">add</mat-icon>
          <span>Lägg ytterligare ett land</span>
        </div>
      </button>
    </div>
  }
</form>